import { gql } from '@apollo/client'

export const REMOVE_WORKSPACE_COLLABORATOR = gql`
  mutation RemoveWorkspaceCollaborator($workspaceId: UUID!, $teamId: ID!, $userId: ID!) {
    removeWorkspaceCollaborator(workspaceId: $workspaceId, teamId: $teamId, userId: $userId) {
      success
    }
  }
`
